/**
 * いまのうにこ用のスライダーコンテンツ
 *  ※Swiperのライブラリが読み込まれている前提
 */
export default class nowSlider extends HTMLElement {
    constructor() {
      super();
  
      const nowSwiper = new Swiper("unico-now-slider .swiper", {
        slidesPerView: 1.52,
        spaceBetween: 5,
        loop: true,
        centeredSlides: true,
        paginationClickable: true,
        speed: 700,
        autoplay: {
          delay: 7000,
          disableOnInteraction: false,
          waitForTransition: false,
        },
        navigation: {
          nextEl: 'unico-now-slider .swiper-button-next',
          prevEl: 'unico-now-slider .swiper-button-prev',
        },
        on: {
            transitionStart: function(){
            var videos = document.querySelectorAll('unico-now-slider .swiper video');

            Array.prototype.forEach.call(videos, function(video){
                video.pause();
            });
            },
            transitionEnd: function(){
                var activeSlide = document.querySelector('unico-now-slider .swiper-slide-active');
                var targetSlideVideo = activeSlide.getElementsByTagName('video')[0];
                targetSlideVideo.play();
            }
        }
      });
    }
  }
  